export default [
  {
    title: 'Note',
    type: 'textarea',
    data: '',
    required: true,
    initialValue: '',
    note_text: '',
    additional: '',
    dataIndex: 'note',
    order: 0,
  }, {
    title: 'Startdate',
    type: 'datetime',
    data: '',
    required: true,
    initialValue: '',
    note_text: '',
    additional: '',
    dataIndex: 'startdate',
    order: 1,
  }, {
    title: 'Enddate',
    type: 'datetime',
    data: '',
    initialValue: '',
    note_text: '',
    additional: '',
    dataIndex: 'enddate',
    order: 2,
  }, {
    title: 'Status',
    type: 'select',
    data: [
      {
        alias: 'a',
        value: 'Active'
      }, {
        alias: 'i',
        value: 'Inactive'
      }
    ],
    initialValue: 'a',
    note_text: '',
    additional: '',
    dataIndex: 'status',
    order: 3
  },
]